import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const BenefitDetailCard = ({ benefitDetails, note=null }) => {
  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: { xs:2 , md: 3 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img src={benefitDetails?.logo_url} alt="logo" style={{ maxHeight: 50, maxWidth: 50 }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2 }}>
            <Typography variant="h2">{benefitDetails?.name}</Typography>
            <Typography variant="body1" sx={{ color: '#636363' }}>{benefitDetails?.description}</Typography>
          </Box>
        </Box>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 600,
            display: 'block',
            color: benefitDetails?.status?.type === 'success' ? '#008000' : '#CC0000',
            textAlign: 'right',
          }}
        >
          {benefitDetails?.status?.label}
        </Typography>
      </Box>
      {benefitDetails?.footer_text && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1, height: '100%' }}>
          <Typography variant="labelD" sx={{ color: '#333' }}>
            {benefitDetails?.footer_text?.label}
          </Typography>
          <Typography variant="body1" sx={{ color: '#333'}}>
            {benefitDetails?.footer_text?.value}
          </Typography>
        </Box>
      )}
      {benefitDetails?.gross && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1, height: '100%' }}>
          <Typography variant="labelD" sx={{ color: '#333' }}>
            {benefitDetails?.gross?.label}
          </Typography>
          <Typography variant="body1" sx={{ color: '#333', fontWeight: 600 }}>
            {benefitDetails?.gross?.value}
          </Typography>
        </Box>
      )}
      {benefitDetails?.gross?.note && <Typography variant="p3" sx={{ color: '##8C8C8C', mt:0.5}}>{benefitDetails?.gross?.note}</Typography>}
      {benefitDetails?.net && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1, height: '100%' }}>
          <Typography variant="labelD" sx={{ color: '#333' }}>
            {benefitDetails?.net?.label}
          </Typography>
          <Typography variant="body1" sx={{ color: '#333', fontWeight: 600 }}>
            {benefitDetails?.net?.value}
          </Typography>
        </Box>
      )}
      {benefitDetails?.net?.note && 
        <Box sx={{ display: 'flex', alignItems: 'center', mt:0.5 }}>
          <InfoOutlined sx={{ fontSize: '16px', color: '##8C8C8C', mr:0.5}} /> 
          <Typography variant="p3" sx={{ color: '##8C8C8C'}}>{benefitDetails?.net?.note}</Typography>
        </Box>
      }
    </React.Fragment>
  );
};

export default BenefitDetailCard;
